import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';

@customElement('gz-banner')
export class GzBannerWebComponent extends LitElement {
  @property({ type: String, reflect: true })
  logoCssClass = '';

  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="wrapper" part="banner-wrapper">
        <div class="container d-flex flex-row">
          <div class="content d-flex flex-column">
            <div class="title-logo ${this.logoCssClass}" part="logo"></div>
            <slot></slot>
          </div>
        </div>
        <svg class="logo" part="bitdefender-logo" width="611" height="611" viewBox="0 0 611 611" fill="none">
          <path d="M305.36 1C137.27 1 1 137.27 1 305.36C1 473.45 137.27 609.72 305.36 609.72C473.45 609.72 609.72 473.45 609.72 305.36C609.72 137.27 473.46 1 305.36 1ZM321.63 464.59L321.7 464.66H206.9V198.27C206.9 183.76 204.36 180.73 184.79 164.7L168.42 150.77V146.02H331.16C379.31 146.02 428.8 168.1 428.8 226.15C428.8 262.16 406.31 285.99 373.46 295.93V296.76C413.01 300.45 443.01 334.02 442.24 373.73C442.24 443.06 381.92 464.59 321.63 464.59ZM361.08 262.37C368.35 255.42 372.34 245.73 372.09 235.68C372.59 225.42 368.73 215.43 361.46 208.17C351.8 199.06 342.1 194.69 310.53 194.69H263.65V275.68H315.24C338.66 275.68 351.52 271.24 360.91 262.3L361.08 262.37ZM318.13 324.27H263.65V416.09H315.86C345.13 416.09 385.57 411.1 385.57 369.28C385.57 335.95 364.01 324.26 318.13 324.26V324.27Z" stroke="var(--blue-layout-400-primary)" stroke-width="2" stroke-miterlimit="10"/>
        </svg>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    gzBanner: GzBannerWebComponent;
  }
}
